import styled from "styled-components";
import theme from '../../theme';

const OriginalPrice = styled.span`
    text-decoration: ${props => props?.textDecoration || `line-through`};
    font-size: ${props => props.fontSize ? props.fontSize : theme.fontSize.originalPrice}px;
`

export default OriginalPrice